import React, { useState, useEffect } from "react";
import { getS3URL } from "../../../../../../../_helpers";
import CourseFile from "../../../CourseFileUpload";
// import OverlayContainer from "@components/Overlay/OverlayContainer";
// import CoursePreview from "../../../../../../Courses/CoursePreview/CoursePreview";
import CourseSectionDocument from "./CourseEditImage/CourseSectionDocument";
import { CourseSection } from "../CourseSection";
import { documentTypeUrl } from "../../../../../../../_constants/staticData";
import TextEditor from "../TextEditor";
import { FaChevronDown, FaChevronUp, FaTrash } from "react-icons/fa";

const EditableChapter = ({
  // mainTitle,
  title,
  add,
  fetchAll,
  content,
  formValues,
  history,
  files,
  scroms,
  id,
  handleEditorStateChange,
  index,
  handleInputChange,
  courseID,
  courseFile,
  setFormValues,
  // syllabusId,
  // syllabusName,
  setSelectedSyllabus,
  selectedSyllabus
}) => {
  const [isactive, setActive] = useState({
    richTextEditorShow: false,
    videoShow: false,
    imageShow: false,
    docShow: false,
    video: null,
  });

  const [isActive, setIsActive] = useState(false);

  const [showCoursePreview, setShowCoursePreview] = useState(false);

  const handleraccordion = () => {
    setIsActive(!isActive);
    setActive({ ...isactive, richTextEditorShow: false });
  };

  const refreshData = (values) => {
    fetchAll();
  };
  const [active, setshowActive] = useState(false);
  const handleAddCourseMaterial = (event) => {
    event.preventDefault();
    setshowActive((state) => !state);
  };

  const removeFormFields = (event, index, property) => {
    event.preventDefault();
    let newFormValues = [...formValues[property]];
    newFormValues.splice(index, 1);
    setFormValues({ ...formValues, [property]: newFormValues });
  };

  const courseFileAdd = (sectionIndex, formValues) => (content) => {
    if (content != null && typeof content == "object" && content.length > 0) {
      const filterScromData = content.filter(
        (items) => items.type === "application/x-zip-compressed"
      );
      const filterFilesData = content.filter(
        (items) => items.type !== "application/x-zip-compressed"
      );
      if (filterScromData) {
        const previousCourseSection = [...formValues.courseSections];
        previousCourseSection[sectionIndex].scroms = filterScromData;
        setFormValues({
          ...formValues,
          courseSections: previousCourseSection,
        });
      }
      if (filterFilesData) {
        const previousCourseSection = [...formValues.courseSections];
        previousCourseSection[sectionIndex].files = filterFilesData;
        setFormValues({
          ...formValues,
          courseSections: previousCourseSection,
        });
      }
    }
  };

  // grouping SyllabusId AND syllabusName with courseID
  const syllabusList = formValues.syllabus || [];


  return (
    <>
      <div className="accordion-item">
        {add && (
          <div className="mycoursedetails flex mr-8 p-3">
            {/* <div>{!isactive.richTextEditorShow ? mainTitle : ""}</div> */}
            <div>{!isactive.richTextEditorShow ? title : ""}</div>
            <div className="expn-elte-btn">
              <button
                className="course-chapter-expand"
                onClick={handleraccordion}
              >
                {isActive ? <FaChevronUp className="!text-lg" /> : <FaChevronDown className="!text-lg" />}
              </button>
              <button
                className="courseedit-delete"
                onClick={(event) =>
                  removeFormFields(event, index, "courseSections")
                }
              >
                <FaTrash className="!text-lg" />
              </button>
            </div>
          </div>
        )}
        {isActive && (
          <div className="accordion-content border-top-content">
            <div className="accordion-contentDescription-Course accordion-contentSection ">
              <div className="flex-end-accordin-new-para">
                <button
                  onClick={() =>
                    setActive((isactive) => ({
                      ...isActive,
                      richTextEditorShow: !isactive.richTextEditorShow,
                    }))
                  }
                >
                  {isactive.richTextEditorShow ? "Update -" : "Edit +"}
                </button>
              </div>
            </div>

            <div className="accordion-contentDescription-Course">
              {isactive.richTextEditorShow === false && (
                <>
                  <div>
                    {/* <div className="mb-3">
                      <h1 className="font-bold">MainTitle</h1>
                      {formValues.courseSections[index]?.mainTitle && (
                        <h3 className="ml-2">{formValues.courseSections[index].mainTitle}</h3>
                      )}
                    </div> */}
                    <div className="mb-3">
                      <h1 className="font-bold">Title</h1>
                      {formValues.courseSections[index]?.name && (
                        <h3 className="ml-2">{formValues.courseSections[index].name}</h3>
                      )}
                    </div>

                    <h1 className="font-bold mb-2">Description</h1>
                    {content !== null && (
                      <span>
                        {content && (
                          <div
                            className="content-data"
                            dangerouslySetInnerHTML={{
                              __html: content,
                            }}
                          />
                        )}
                      </span>
                    )}
                    <div className="content-des-off">
                      <h4 className="edit-content-des">Video Link</h4>
                      <span>{formValues.courseSections[index].videoLink}</span>
                    </div>
                    {/* {formValues.courseFiles && formValues.courseFiles.length > 0 && (
                      <div className="course-files">
                        <h4>Attached Files</h4>
                        <ul>
                          {formValues.courseFiles.map((file, fileIndex) => {
                            const fileUrl = `http://localhost:3000/${file.fileName}`;
                            const fileName = file.originalName || file.fileName.split('/').pop();
                            return (
                              <li key={fileIndex}>
                                <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                  {fileName}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )} */}


                  </div>
                </>
              )}

              {isactive.richTextEditorShow === true && (
                <>
                  <div className="rich-inputFeild">
                    {/* {syllabusList && (
                      <div className="form-inline section-description mb-3">
                        <h1 className="font-bold">Syllabus</h1>
                        <select
                          className="form-control !mt-2"
                          value={selectedSyllabus?.id || ""}
                          onChange={(e) => {
                            const selected = syllabusList.find(
                              (item) => item?.id === parseInt(e.target.value)
                            );
                            console.log("selected syllabus", selected);
                            setSelectedSyllabus({
                              id: selected?.id,
                              name: selected?.name
                            })
                            handleInputChange(
                              index,
                              "courseSections",
                              selected?.name,
                              "syllabusName",
                              true
                            );
                            handleInputChange(
                              index,
                              "courseSections",
                              selected?.id,
                              "syllabusId",
                              true
                            );
                          }}
                        >
                          <option value="">Select Syllabus</option>
                          {syllabusList.map((syllabus) => (
                            <option key={syllabus.id} value={syllabus.id}>
                              {syllabus.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )} */}
                    {/* <div className="!mb-2">
                      <h4 className="!mb-2 font-bold">Main Title</h4>
                      <input
                        type="text"
                        name="courseSections"
                        value={formValues.courseSections[index].mainTitle}
                        onChange={({ target }) =>
                          handleInputChange(
                            index,
                            target.name,
                            target.value,
                            "mainTitle",
                            true
                          )
                        }
                      />
                    </div> */}
                    <div className="!mb-2">
                      <h4 className="!mb-2 font-bold">Section {index + 1} - Title</h4>
                      {/* <input
                        type="text"
                        name="courseSections"
                        value={formValues.courseSections[index].name}
                        onChange={({ target }) =>
                          handleInputChange(
                            index,
                            target.name,
                            target.value,
                            "name",
                            true
                          )
                        }
                      /> */}
                      <select className="form-control !mt-2" value={formValues.courseSections[index].name} name="courseSections"
                        onChange={({ target }) =>
                          handleInputChange(index, target.name, target.value, "name", true)
                        }
                      >
                        <option value="">Select Syllabus</option>
                        {syllabusList.map((syllabus) => (
                          <option key={syllabus.id} value={syllabus.name}>
                            {syllabus.name}
                          </option>
                        ))}
                      </select>

                      {formValues.courseSections && (
                        <TextEditor
                          formState={content}
                          history={history}
                          handleEditorStateChange={handleEditorStateChange(
                            "courseSections",
                            "description",
                            index
                          )}
                        />
                      )}
                    </div>
                    <div className="form-inline section-description">
                      <h4 className="font-bold">Section {index + 1} - Video / Document Link</h4>
                      <input
                        type="text"
                        name="courseSections"
                        placeholder="Video / Document Link"
                        value={formValues.courseSections[index].videoLink}
                        onChange={({ target }) =>
                          handleInputChange(
                            index,
                            target.name,
                            target.value,
                            "videoLink",
                            true
                          )
                        }
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div>
              <CourseSectionDocument
                datasource={files}
                scroms={scroms}
                toogle={setShowCoursePreview}
                courseImg={
                  formValues.imageFiles.length > 0
                    ? formValues.imageFiles[0]?.base64
                      ? formValues.imageFiles[0]?.base64
                      : getS3URL(formValues.imageFiles[0].fileName)
                    : documentTypeUrl.brokenImage
                }
                courseName={formValues.courseName && formValues.courseName}
                refreshData={refreshData}
              />

              <div className="define-add-text">
                <a
                  name={index}
                  href="javascript(void);"
                  onClick={handleAddCourseMaterial}
                >
                  + Add Course Material
                </a>
              </div>
              {active && (
                <div className="chapter-section">
                  <div className="course-image-introductionSection">
                    <CourseFile
                      courseFileLimit={5 - files.length}
                      courseFile={courseFile}
                      courseId={courseID}
                      id={id}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {add === undefined && (
          <CourseSection
            current={16}
            index={index}
            section={title}
            handleEditorStateChange={handleEditorStateChange}
            handleInputChange={handleInputChange}
            courseFile={courseFileAdd(index, formValues)}
            removeFormFields={removeFormFields}
            history={history}
            location1={"courseEdit"}
            // syllabusId={syllabusId}
            // syllabusName={syllabusName}
            syllabusList={syllabusList}
            setSelectedSyllabus={setSelectedSyllabus}
            selectedSyllabus={selectedSyllabus}
          />
        )}
      </div>
    </>
  );
};
export default EditableChapter;
